import { ComboboxOption } from 'ui';

const isSameOption = (a: ComboboxOption, b: ComboboxOption) =>
  a.value.toString() === b.value.toString();

export const toggleComboboxOption = <T extends ComboboxOption>(
  selected: T[],
  option: T,
  isMulti = true,
): T[] => {
  if (selected.some((current) => isSameOption(current, option))) {
    return selected.filter((current) => !isSameOption(current, option));
  }

  return isMulti ? [...selected, option] : [option];
};
